// extracted by mini-css-extract-plugin
export default {"container":"Options_container__Aid3i","content":"Options_content__LLycx"};